import React from 'react';
import { SEO } from '../components/seo/SEO';
import { VirtualAdoptionHero } from '../components/virtualAdoption/VirtualAdoptionHero';
import { VirtualAdoptionInfo } from '../components/virtualAdoption/VirtualAdoptionInfo';
import { VirtualAdoptionBenefits } from '../components/virtualAdoption/VirtualAdoptionBenefits';
import { VirtualAdoptionPets } from '../components/virtualAdoption/VirtualAdoptionPets';
import { VirtualAdoptionStories } from '../components/virtualAdoption/VirtualAdoptionStories';
import { VirtualAdoptionContact } from '../components/virtualAdoption/VirtualAdoptionContact';
import { getBreadcrumbSchema } from '../lib/jsonLd';

export function VirtualAdoptionPage() {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Strona główna', url: 'https://znajdki.pl/' },
    { name: 'Wirtualna adopcja', url: 'https://znajdki.pl/wirtualna-adopcja' }
  ]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <SEO 
        title="Adopcja wirtualna zwierząt - Fundacja Znajdki"
        description="Zostań wirtualnym opiekunem psa lub kota! Wspieraj naszych podopiecznych poprzez adopcję wirtualną. Pomagaj zwierzętom pozostającym w fundacji na stałe."
        url="/wirtualna-adopcja"
        image="/images/animals/fundacja-znajdki-zwierzeta-001.webp"
        jsonLd={breadcrumbSchema}
      />

      <VirtualAdoptionHero />

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <VirtualAdoptionInfo />
        <div className="space-y-8">
          <VirtualAdoptionBenefits />
        </div>
      </div>

      <VirtualAdoptionPets />
      <VirtualAdoptionStories />
      <VirtualAdoptionContact />
    </div>
  );
}